export const DeviceUserPinEditSceneTranslation = {
  fi: {
    DeviceUserPinEditScene: {
      title: 'Vaihda pin koodia',
    },
  },
};
